import PostTableFilter from "./post-table-filter";


const PostFilters = {
    Table: PostTableFilter,
}

export default PostFilters;